// Types for DAYNNIGHT revenue
export const READ_DAYNNIGHT_REVENUE_REQUEST = 'READ_DAYNNIGHT_REVENUE_REQUEST';
export const READ_DAYNNIGHT_REVENUE_SUCCESS = 'READ_DAYNNIGHT_REVENUE_SUCCESS';
export const READ_DAYNNIGHT_REVENUE_FAILURE = 'READ_DAYNNIGHT_REVENUE_FAILURE';

// Types for SHAHVENTURESLLC revenue
export const READ_SHAHVENTURESLLC_REVENUE_REQUEST = 'READ_SHAHVENTURESLLC_REVENUE_REQUEST';
export const READ_SHAHVENTURESLLC_REVENUE_SUCCESS = 'READ_SHAHVENTURESLLC_REVENUE_SUCCESS';
export const READ_SHAHVENTURESLLC_REVENUE_FAILURE = 'READ_SHAHVENTURESLLC_REVENUE_FAILURE';

// Types for UNOVENTURESCO revenue
export const READ_UNOVENTURESCO_REVENUE_REQUEST = 'READ_UNOVENTURESCO_REVENUE_REQUEST';
export const READ_UNOVENTURESCO_REVENUE_SUCCESS = 'READ_UNOVENTURESCO_REVENUE_SUCCESS';
export const READ_UNOVENTURESCO_REVENUE_FAILURE = 'READ_UNOVENTURESCO_REVENUE_FAILURE';

// Types for SOLOVENTURESCO revenue
export const READ_SOLOVENTURESCO_REVENUE_REQUEST = 'READ_SOLOVENTURESCO_REVENUE_REQUEST';
export const READ_SOLOVENTURESCO_REVENUE_SUCCESS = 'READ_SOLOVENTURESCO_REVENUE_SUCCESS';
export const READ_SOLOVENTURESCO_REVENUE_FAILURE = 'READ_SOLOVENTURESCO_REVENUE_FAILURE';

// Types for VIBEZVENTURESLLC revenue
export const READ_VIBEZVENTURESLLC_REVENUE_REQUEST = 'READ_VIBEZVENTURESLLC_REVENUE_REQUEST';
export const READ_VIBEZVENTURESLLC_REVENUE_SUCCESS = 'READ_VIBEZVENTURESLLC_REVENUE_SUCCESS';
export const READ_VIBEZVENTURESLLC_REVENUE_FAILURE = 'READ_VIBEZVENTURESLLC_REVENUE_FAILURE';

// Types for IAVENTURESLLC revenue
export const READ_IAVENTURESLLC_REVENUE_REQUEST = 'READ_IAVENTURESLLC_REVENUE_REQUEST';
export const READ_IAVENTURESLLC_REVENUE_SUCCESS = 'READ_IAVENTURESLLC_REVENUE_SUCCESS';
export const READ_IAVENTURESLLC_REVENUE_FAILURE = 'READ_IAVENTURESLLC_REVENUE_FAILURE';

// Types for SZXVENTURESLLC revenue
export const READ_SZXVENTURESLLC_REVENUE_REQUEST = 'READ_SZXVENTURESLLC_REVENUE_REQUEST';
export const READ_SZXVENTURESLLC_REVENUE_SUCCESS = 'READ_SZXVENTURESLLC_REVENUE_SUCCESS';
export const READ_SZXVENTURESLLC_REVENUE_FAILURE = 'READ_SZXVENTURESLLC_REVENUE_FAILURE';

// Types for VRLVENTURESLLC revenue
export const READ_VRLVENTURESLLC_REVENUE_REQUEST = 'READ_VRLVENTURESLLC_REVENUE_REQUEST';
export const READ_VRLVENTURESLLC_REVENUE_SUCCESS = 'READ_VRLVENTURESLLC_REVENUE_SUCCESS';
export const READ_VRLVENTURESLLC_REVENUE_FAILURE = 'READ_VRLVENTURESLLC_REVENUE_FAILURE';

// Types for SCDLVENTURESLLC revenue
export const READ_SCDLVENTURESLLC_REVENUE_REQUEST = 'READ_SCDLVENTURESLLC_REVENUE_REQUEST';
export const READ_SCDLVENTURESLLC_REVENUE_SUCCESS = 'READ_SCDLVENTURESLLC_REVENUE_SUCCESS';
export const READ_SCDLVENTURESLLC_REVENUE_FAILURE = 'READ_SCDLVENTURESLLC_REVENUE_FAILURE';

// Types for TMPEVENTURESLLC revenue
export const READ_TMPEVENTURESLLC_REVENUE_REQUEST = 'READ_TMPEVENTURESLLC_REVENUE_REQUEST';
export const READ_TMPEVENTURESLLC_REVENUE_SUCCESS = 'READ_TMPEVENTURESLLC_REVENUE_SUCCESS';
export const READ_TMPEVENTURESLLC_REVENUE_FAILURE = 'READ_TMPEVENTURESLLC_REVENUE_FAILURE';

// Types for FRDKVENTURESLLC revenue
export const READ_FRDKVENTURESLLC_REVENUE_REQUEST = 'READ_FRDKVENTURESLLC_REVENUE_REQUEST';
export const READ_FRDKVENTURESLLC_REVENUE_SUCCESS = 'READ_FRDKVENTURESLLC_REVENUE_SUCCESS';
export const READ_FRDKVENTURESLLC_REVENUE_FAILURE = 'READ_FRDKVENTURESLLC_REVENUE_FAILURE';

// Types for CHDLVENTURESLLC revenue
export const READ_CHDLVENTURESLLC_REVENUE_REQUEST = 'READ_CHDLVENTURESLLC_REVENUE_REQUEST';
export const READ_CHDLVENTURESLLC_REVENUE_SUCCESS = 'READ_CHDLVENTURESLLC_REVENUE_SUCCESS';
export const READ_CHDLVENTURESLLC_REVENUE_FAILURE = 'READ_CHDLVENTURESLLC_REVENUE_FAILURE';

// Types for THRNVENTURESLLC revenue
export const READ_THRNVENTURESLLC_REVENUE_REQUEST = 'READ_THRNVENTURESLLC_REVENUE_REQUEST';
export const READ_THRNVENTURESLLC_REVENUE_SUCCESS = 'READ_THRNVENTURESLLC_REVENUE_SUCCESS';
export const READ_THRNVENTURESLLC_REVENUE_FAILURE = 'READ_THRNVENTURESLLC_REVENUE_FAILURE';

// Types for ODOO UTAH revenue
export const READ_ODOO_UTAH_REVENUE_REQUEST = 'READ_ODOO_UTAH_REVENUE_REQUEST';
export const READ_ODOO_UTAH_REVENUE_SUCCESS = 'READ_ODOO_UTAH_REVENUE_SUCCESS';
export const READ_ODOO_UTAH_REVENUE_FAILURE = 'READ_ODOO_UTAH_REVENUE_FAILURE';

// Types for ODOO COLORADO revenue
export const READ_ODOO_COLORADO_REVENUE_REQUEST = 'READ_ODOO_COLORADO_REVENUE_REQUEST';
export const READ_ODOO_COLORADO_REVENUE_SUCCESS = 'READ_ODOO_COLORADO_REVENUE_SUCCESS';
export const READ_ODOO_COLORADO_REVENUE_FAILURE = 'READ_ODOO_COLORADO_REVENUE_FAILURE';

// Types for ODOO OKLAHOMA revenue
export const READ_ODOO_OKLAHOMA_REVENUE_REQUEST = 'READ_ODOO_OKLAHOMA_REVENUE_REQUEST';
export const READ_ODOO_OKLAHOMA_REVENUE_SUCCESS = 'READ_ODOO_OKLAHOMA_REVENUE_SUCCESS';
export const READ_ODOO_OKLAHOMA_REVENUE_FAILURE = 'READ_ODOO_OKLAHOMA_REVENUE_FAILURE';

// Types for revenue
export const READ_REVENUE_REQUEST = 'READ_REVENUE_REQUEST';
export const READ_REVENUE_SUCCESS = 'READ_REVENUE_SUCCESS';
export const READ_REVENUE_FAILURE = 'READ_REVENUE_FAILURE';

export const READ_REVENUE_FILTER_REQUEST = 'READ_REVENUE_FILTER_REQUEST';
export const READ_REVENUE_FILTER_SUCCESS = 'READ_REVENUE_FILTER_SUCCESS';
export const READ_REVENUE_FILTER_FAILURE = 'READ_REVENUE_FILTER_FAILURE';
